import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                className="flex h-screen items-center justify-center text-gray-500 text-sm"
                data-testid="auth-loading"
            >
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

    if (user.must_change_password && location.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
